export default [
    {
        colName: "prNumber", 
    },
    
]